import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication/authentication.service';

@Component({
    selector: 'error-pagenotfound',
    templateUrl: './pagenotfound.component.html',
    styles: [],
    standalone: false
})
export class PageNotFoundComponent {
    constructor(private auth: AuthenticationService, private router: Router) { }

    goHome(event: Event): void {
        event.preventDefault();
        this.router.navigateByUrl(this.auth.getHomeRoute());
    }
}
